export default __webpack_public_path__ + "static/media/list_main_14_1.b59924bb.png";